import React, { useState } from "react";
import { Hidden } from "@material-ui/core";
import usePathListener from "hooks/usePathListener";
import Item from "./Item";

const NavQuickLinks = ({ data, openItem = null, setOpenItem = () => {} }) => {
  const { pathname } = usePathListener();

  return (
    <div className="nav-quicklinks flex-direction-row">
      <Hidden smDown>
        {data &&
          data.map((item, idx) => (
            <Item
              key={idx}
              {...item}
              pathname={pathname}
              setOpenItem={setOpenItem}
              openItem={openItem}
            />
          ))}
      </Hidden>
    </div>
  );
};

export default NavQuickLinks;
